export var SupportedFeatures;
(function (SupportedFeatures) {
    SupportedFeatures["Coins"] = "COINS";
    SupportedFeatures["Messages"] = "MESSAGES";
    SupportedFeatures["UserUpdate"] = "USER_UPDATE";
    SupportedFeatures["Competitions"] = "COMPETITIONS";
    SupportedFeatures["Banners"] = "BANNERS";
})(SupportedFeatures || (SupportedFeatures = {}));
export var WalletStatus;
(function (WalletStatus) {
    WalletStatus["Active"] = "ACTIVE";
    WalletStatus["Disabled"] = "DISABLED";
})(WalletStatus || (WalletStatus = {}));
export var UserWalletTypeEnum;
(function (UserWalletTypeEnum) {
    UserWalletTypeEnum["Trading"] = "TRADING";
    UserWalletTypeEnum["Live"] = "LIVE";
    UserWalletTypeEnum["Demo"] = "DEMO";
    UserWalletTypeEnum["PropFunded"] = "PROP_FUNDED";
    UserWalletTypeEnum["PropChallenge"] = "PROP_CHALLENGE";
    UserWalletTypeEnum["Affiliate"] = "AFFILIATE";
})(UserWalletTypeEnum || (UserWalletTypeEnum = {}));
export var WalletPlatform;
(function (WalletPlatform) {
    WalletPlatform["WINTRADO"] = "WINTRADO";
    WalletPlatform["MT5"] = "MT5";
})(WalletPlatform || (WalletPlatform = {}));
export var TradingType;
(function (TradingType) {
    TradingType["Hedging"] = "HEDGING";
    TradingType["Netting"] = "NETTING";
})(TradingType || (TradingType = {}));
export var LoyaltyLevelName;
(function (LoyaltyLevelName) {
    LoyaltyLevelName["BRONZE"] = "bronze";
    LoyaltyLevelName["SILVER"] = "silver";
    LoyaltyLevelName["GOLD"] = "gold";
    LoyaltyLevelName["PLATINUM"] = "platinum";
    LoyaltyLevelName["DIAMOND"] = "diamond";
})(LoyaltyLevelName || (LoyaltyLevelName = {}));
